import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getHistory } from "../../../../store/actions/maintenanceBillToActions";
import {
  ReusableHistoryViewer,
  mapDescriptionHistoryRows,
} from "../../../../components/History";

const PAGE_SIZE = 20;

const BILL_TO_HISTORY_ENTITY_LABELS = {
  bill_to: "Bill To",
};

export default function BillToHistory({ code }) {
  const dispatch = useDispatch();
  const ordersLocation = useSelector(
    ({ orderReducer }) => orderReducer.ordersLocation,
  );

  const fetchBillToHistoryPage = useCallback(
    async (page, size) => {
      if (!code || !ordersLocation?.locationNumber) {
        return {
          history: [],
          pagination: { hasMore: false },
        };
      }

      const res = await dispatch(
        getHistory(
          ordersLocation.locationNumber,
          code,
          page,
          size,
        ),
      );

      const rawHistory = Array.isArray(res?.data) ? res.data : [];
      const history = mapDescriptionHistoryRows(rawHistory, {
        entity: "bill_to",
        entityId: code || "general",
        fieldName: "Description",
        pageSeed: page,
      });

      return {
        history,
        pagination: { hasMore: rawHistory.length >= size },
      };
    },
    [code, dispatch, ordersLocation?.locationNumber],
  );

  return (
    <ReusableHistoryViewer
      fetchHistoryPage={fetchBillToHistoryPage}
      reloadKey={`${ordersLocation?.locationNumber || "none"}-${code || "none"}`}
      title="Bill To History"
      searchPlaceholder="Search by user or description"
      entityLabels={BILL_TO_HISTORY_ENTITY_LABELS}
      initialExpandedGroups={3}
      pageSize={PAGE_SIZE}
    />
  );
}
